
import { emptyArray } from '@kodadot1/minimark/utils'
import { Attribute } from '@kodadot1/minimark/common'
import { Component, Emit, Prop, Watch, mixins } from 'nuxt-property-decorator'
import { Debounce } from 'vue-debounce-decorator'
import { formatDistanceToNow } from 'date-fns'

import { Offer } from './types'
import OfferMixin from '@/utils/mixins/offerMixin'
import PrefixMixin from '@/utils/mixins/prefixMixin'
import { getKusamaAssetId } from '@/utils/api/bsx/query'
import {
  NeoButton,
  NeoSelect,
  NeoTable,
  NeoTableColumn,
  NeoTooltip,
} from '@kodadot1/brick'

const components = {
  Identity: () => import('@/components/identity/IdentityIndex.vue'),
  Money: () => import('@/components/bsx/format/TokenMoney.vue'),
  Pagination: () => import('@/components/rmrk/Gallery/Pagination.vue'),
  NeoTable,
  NeoTableColumn,
  NeoTooltip,
  NeoSelect,
  NeoButton,
}

@Component({ components, filters: { formatDistanceToNow } })
export default class OfferTable extends mixins(OfferMixin, PrefixMixin) {
  @Prop({ type: Array, default: () => emptyArray<Attribute>() })
  public offers!: Offer[]
  @Prop(Boolean) public isOwner!: boolean
  @Prop(Boolean) public isBsxStats!: boolean
  @Prop({ type: String, default: '' }) public headerText!: string
  @Prop(Boolean) public isCollection!: boolean
  @Prop({ type: Boolean, default: false }) public displayCollection!: boolean
  public currentBlock = 0
  public itemsPerPage = 20
  public currentPage = parseInt(this.$route.query?.page as string) || 1

  @Emit('select')
  tellFrens(caller: string, withdraw: boolean) {
    return {
      caller,
      withdraw,
    }
  }

  get assetId() {
    return getKusamaAssetId(this.urlPrefix)
  }

  @Watch('currentPage')
  watchPageValue(val) {
    this.replaceUrl(String(val))
  }

  @Debounce(100)
  replaceUrl(value: string, key = 'page') {
    this.$router
      .replace({
        path: String(this.$route.path),
        query: { ...this.$route.query, [key]: value },
      })
      .catch(this.$consola.warn /*Navigation Duplicate err fix later */)
  }
}
